import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import cx from 'classnames'

import ShoppingCartProduct from './ShoppingCartProduct'
import { api } from '../../../../api/integrationAPI'
import { isSafari } from '../../../shared/utils'
import { sendEvent } from '../../../shared/analytics'

import './ShoppingCart.scss'

export default class ShoppingCart extends React.Component {

  constructor (props) {
    super(props)
    this.state = { checkoutUrl: null }
    this.isSafari = isSafari()
  }

  onDelete = (productId) => {
    api.deleteFromCart(productId)
  }

  onBack = () => {
    if (this.state.checkoutUrl) {
      this.setState({ checkoutUrl: null })
    } else {
      this.props.onClose()
    }
  }

  onCheckout = () => {
    const { cart, prodMode } = this.props
    if (cart && cart.checkoutUrl) {
      if (prodMode) sendEvent('Purchase', 'Start')
      const appName = window.shopName || (window.appId && window.appId.substring(1))
      if (appName && !appName.startsWith('preview_')) {
        const url = window.clientId ? `${cart.checkoutUrl}?_ga=${window.clientId}&appName=${appName}&templateId=${window.settings.templateId}` : cart.checkoutUrl
        if (this.isSafari) {
          window.open(url, '_self')
        } else {
          api.deleteCartHistory()
          this.setState({ checkoutUrl: url })
        }
      } else {
        console.log('can not Checkout in app preview')
      }
    }
  }

  renderCheckoutPage () {
    const { isVisible } = this.props
    if (isVisible && !this.isSafari && this.state.checkoutUrl) {
      return (
        <div className='ou_cart__checkout' key='iframe'>
          <iframe
            src={this.state.checkoutUrl}
            ref={ref => (this.iframe = ref)}
            className='ou_cart__checkout-iframe'
          />
        </div>
      )
    }
  }

  renderCheckoutButton () {
    let className = 'ou_cart__button'
    const appName = window.shopName || (window.appId && window.appId.substring(1))
    console.log('renderCheckout button appName', appName)
    if (!this.state.checkoutUrl || appName.startsWith('preview_')) {
      console.log('shckout button disabled')
      className = cx('ou_cart__button', 'ou_cart__button--muted')
    }
    return (
      <button
        className={className}
        onClick={this.onCheckout}
      >
        Checkout
      </button>
    )
  }

  render () {
    // console.log('ShoppingCart render')
    const { cart, isVisible } = this.props
    const products = (cart) ? cart.products : []
    const subtotal = (cart) ? cart.subtotal : 0
    const shouldContentBeScrolled = products.length > 2
    return (
      <CSSTransitionGroup
        transitionName='ou_cart'
        transitionEnterTimeout={350}
        transitionLeaveTimeout={250}
      >
        {isVisible && <div className={'ou_cart'} key='cart'>
          <div className={'ou_cart__back-button'} onClick={this.onBack} />
          {!this.state.checkoutUrl && <div className={'ou_cart__title'}>Shopping Cart</div>}
          {!this.state.checkoutUrl && <div className={'ou_cart__content js-scroll'}>
            <div className={'ou_cart__products'}>
              {/* we can't use product.id as key because they are not unique */}
              {/* we also can't use array index as key because when item is deleted, there are problems */}
              {products.map((product, i) =>
                <ShoppingCartProduct
                  key={i}
                  title={product.title}
                  price={product.price}
                  image={product.image}
                  variant={product.variant}
                  productId={product.id}
                  onDelete={this.onDelete}
                  enableScroll={shouldContentBeScrolled}
                />
              )}
            </div>
            <table className={'ou_cart__table'}>
              <tbody>
                {/* <tr><td>Ground Shipping Standard</td><td>Free</td></tr> */}
                {/* <tr><td>Sales Tax</td><td>$2.00</td></tr> */}
                <tr><td><b>Subtotal</b></td><td>${subtotal}</td></tr>
              </tbody>
            </table>
            <div className={'ou_cart__buttons'}>
              <button className={'ou_cart__button ou_cart__button--muted'} onClick={this.props.onClose}>
                Continue Shopping
              </button>
              {this.renderCheckoutButton()}
            </div>
          </div>}
        </div>}
        {this.renderCheckoutPage()}
      </CSSTransitionGroup>
    )
  }

  static propTypes = {
    onClose: PropTypes.func,
    cart: PropTypes.object,
    isVisible: PropTypes.bool,
    prodMode: PropTypes.bool
  }
}



// WEBPACK FOOTER //
// ./src/templates/outSide/components/cart/ShoppingCart.js